import { render, staticRenderFns } from "./ProjectPermissionComponent.vue?vue&type=template&id=11fd12d7&lang=pug"
import script from "./ProjectPermissionComponent.vue?vue&type=script&lang=js"
export * from "./ProjectPermissionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11fd12d7')) {
      api.createRecord('11fd12d7', component.options)
    } else {
      api.reload('11fd12d7', component.options)
    }
    module.hot.accept("./ProjectPermissionComponent.vue?vue&type=template&id=11fd12d7&lang=pug", function () {
      api.rerender('11fd12d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/components/ProjectPermissionComponent.vue"
export default component.exports